import { style } from '@vanilla-extract/css';

export const input = style({
  border: 'none',
  outline: 'none',
  // tailwind adds input[type=email] background-color: fff; so we need to override it
  backgroundColor: 'var(--input-background-color) !important',
  fontFamily: 'var(--input-font-family)',
  fontWeight: 'var(--input-font-weight)',
  fontSize: 'var(--input-font-size)',
  textAlign: 'var(--text-align, left)',
  '::placeholder': {
    color: 'var(--placeholder-color)',
    fontFamily: 'var(--input-font-family)',
    fontWeight: 'var(--input-font-weight)',
    fontSize: 'var(--input-font-size)',
    textAlign: 'var(--text-align, left)',
  },
  ':focus': {
    fontSize: 'var(--input-font-size) !important',
  },
  '@media': {
    'only screen and (--mobile)': {
      fontSize: 'var(--mobile-input-font-size)',
      ':focus': {
        fontSize: 'var(--mobile-input-font-size) !important',
      },
      '::placeholder': {
        fontSize: 'var(--mobile-input-font-size)',
      },
    },
  },
});

export const optionWrapperStyle = style({
  display: 'flex',
  gap: '6px',
  alignItems: 'flex-start',
});

export const labelStyle = style({
  display: 'block',
  fontSize: '1rem',
  fontWeight: '500',
  lineHeight: '1.5rem',
  color: 'var(--input-label-color)',
  fontFamily: 'var(--input-font-family)',
  textAlign: 'var(--text-align, left)',
  padding: '0px',
  cursor: 'pointer',
  flex: 1,
  minWidth: 0,
});

export const checkboxStyle = style({
  all: 'unset',
  width: '16px',
  height: '16px',
  flexShrink: 0,
  borderColor: 'var(--input-border-color)',
  borderWidth: 'var(--input-border-width)',
  borderStyle: 'solid',
  borderRadius: 'var(--input-checkbox-radius)',
  display: 'inline-block',
  cursor: 'pointer',
  position: 'relative',
  // tailwind adds [type="checkbox"] background-color: fff; so we need to override it
  backgroundColor: 'var(--input-radio-checkbox-background-color) !important',
  marginTop: '4px',
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  padding: 0,
  WebkitTapHighlightColor: 'transparent',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  boxSizing: 'border-box',
  selectors: {
    '&:checked': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
    '&:checked::after': {
      content: '""',
      position: 'absolute',
      top: '45%',
      left: '50%',
      transform: 'translate(-50%, -50%) rotate(45deg)',
      width: '4px',
      height: '8px',
      borderRight: '2px solid var(--input-radio-checkbox-background-color)',
      borderBottom: '2px solid var(--input-radio-checkbox-background-color)',
      pointerEvents: 'none',
    },
    '&:hover:not(:checked)': {
      borderColor: 'var(--input-radio-checkbox-accent-color)',
    },
    '&:focus, &:focus-visible, &:active, &:-moz-focusring, &::-moz-focus-inner': {
      outline: 'none !important',
      boxShadow: 'none !important',
      border: 'inherit !important',
    },
    '&:checked:focus, &:checked:active, &:checked:hover, &:checked:focus-visible': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
    '&:not(:checked)': {
      outline: 'none',
      boxShadow: 'none',
    },
  },
});

export const fieldGroupStyle = style({
  alignItems: 'var(--text-align-items, start)' as never,
});

export const radioStyle = style({
  all: 'unset',
  width: '16px',
  height: '16px',
  flexShrink: 0,
  borderColor: 'var(--input-border-color)',
  borderWidth: 'var(--input-border-width)',
  borderStyle: 'solid',
  display: 'inline-block',
  borderRadius: '50%',
  cursor: 'pointer',
  position: 'relative',
  // tailwind adds [type="radio"] background-color: fff; so we need to override it
  backgroundColor: 'var(--input-radio-checkbox-background-color) !important',
  marginTop: '4px',
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  padding: 0,
  WebkitTapHighlightColor: 'transparent',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  transform: 'translateZ(0)',
  backfaceVisibility: 'hidden',
  selectors: {
    '&:checked': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
    '&:checked::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      backgroundColor: 'var(--input-radio-checkbox-background-color)',
      pointerEvents: 'none',
    },
    '&:hover:not(:checked)': {
      borderColor: 'var(--input-radio-checkbox-accent-color)',
    },
    '&:focus, &:focus-visible, &:active, &:-moz-focusring, &::-moz-focus-inner': {
      outline: 'none !important',
      boxShadow: 'none !important',
      border: 'inherit !important',
    },
    '&:checked:focus, &:checked:active, &:checked:hover, &:checked:focus-visible': {
      backgroundColor: 'var(--input-radio-checkbox-accent-color) !important',
      borderColor: 'var(--input-radio-checkbox-accent-color) !important',
    },
  },
});
